export { default as Home } from './Home';
export { default as Categories } from './Categories';
export { default as Address } from './Address';
export { default as Users } from './Users';
export { default as Settings } from './Settings';
export { default as AdminLayout } from './AdminLayout';
export { default as UsersProfils } from './UsersProfils';



// WEBPACK FOOTER //
// ./src/features/admin/index.js